import { FiHome, FiInfo, FiMessageSquare } from "react-icons/fi";

// Navigation links for the application. These are on the left of the Navbar/Sidebar
export const navLinks = [
  { to: "/", label: "RAD Tool", icon: FiHome },
  { to: "/about", label: "About", icon: FiInfo },
  { to: "/feedback", label: "Feedback", icon: FiMessageSquare },
];
